import React from "react";

import { getSubmissionCategoryConfig } from "./submissionCategoryMap";

import "./SubmissionTypeLabel.css";

export default function SubmissionTypeLabel({ submission }) {
  const categoryConfig = getSubmissionCategoryConfig(submission);

  if (!categoryConfig) {
    return "-";
  }

  const { label, icon: Icon } = categoryConfig;

  return (
    <span className="SubmissionTypeLabel" title={label}>
      <Icon className="SubmissionTypeLabel__Icon" aria-hidden />
      <span className="SubmissionTypeLabel__Text">{label}</span>
    </span>
  );
}
